import { createSlice } from '@reduxjs/toolkit';

type iInitialState = {
  globalClient: null 
}

const initialState: iInitialState = {
  globalClient: null
};

const partnerSlice = createSlice({
  name: 'partner',
  initialState,
  reducers: {
    setGlobalClient: (state, { payload }) => {
      state.globalClient = { ...payload };
    }
  }
});
export const { setGlobalClient } = partnerSlice.actions;
export default partnerSlice.reducer;
